import { type AppState } from "src/core/reducers";

import { type Notification } from '../notification';

export const getNotificationsStack = (state: AppState): Notification[] => {
  return state.notificationsStack;
};
